import Events from "ampersand-events";
import { getStore } from "store";

// Allow legacy app to access this object (also good for debugging)
const App = {
    legacy: {
        sendMessage(message) {
            const legacy = document.getElementById("legacy-app");
            if (legacy && legacy.contentWindow) {
                legacy.contentWindow.postMessage(message, "*");
            }
        },
        onMessage(event) {
            const action = event.data.action;
            if (action) {
                delete event.data.action;
                if (action === "redux-action") {
                    getStore().dispatch(event.data);
                } else {
                    App.trigger(`legacy:${action}`, event.data);
                }
            }
        },
    },
};

Events.createEmitter(App);

export default App;
